import { render, staticRenderFns } from "./Tiket.html?vue&type=template&id=46bea884&scoped=true&"
import script from "./Tiket.js?vue&type=script&lang=js&"
export * from "./Tiket.js?vue&type=script&lang=js&"
import style0 from "./Tiket.scss?vue&type=style&index=0&id=46bea884&lang=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bea884",
  null
  
)

export default component.exports